import {ValueObject} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'
import {SpecificationVehiclesValueObject} from './SpecificationVehiclesValueObject.js'

export class OfferTypeSpecificationVehiclesValueObject extends ValueObject {
  #offerType

  constructor({offerType}) {
    super()
    this.#offerType = offerType
  }

  static empty() {
    return new OfferTypeSpecificationVehiclesValueObject({offerType: SpecificationVehiclesValueObject.empty()})
  }

  static createFromId({id}) {
    if (!SpecificationVehiclesValueObject.isValidId({id})) return OfferTypeSpecificationVehiclesValueObject.empty()

    const {OFFER_TYPES} = ConfigContext.get('vehicleSpecifications')

    const {icon, name} = OFFER_TYPES[id]

    return new OfferTypeSpecificationVehiclesValueObject({
      offerType: SpecificationVehiclesValueObject.createFromLiterals({icon, id, name})
    })
  }

  get icon() {
    return this.#offerType.icon
  }

  get id() {
    return this.#offerType.id
  }

  get name() {
    return this.#offerType.name
  }

  get value() {
    return this.#offerType.value
  }

  isEmpty() {
    return this.#offerType.isEmpty()
  }
}
